module.exports = __webpack_public_path__ + "static/media/black-back-arrow.a21dd539.svg";